const countryToChange = {
    ARG: {
        compra: "ARG-Compra",
        name: "ARG"
    },
    BOL: {
        compra: "BOB-Compra",
        name: "BOB"
    },
    CHL: {
        compra: "CLP-Compra",
        name: "CLP"
    },
    COL: {
        compra: "COP-Compra",
        name: "COP"
    },
    MEX: {
        compra: "MXN-Compra",
        name: "MXN"
    },
    PER: {
        compra: "PEN-Compra",
        name: "PEN"
    },
    USA: {
        compra: "USA-Compra",
        name: "USD"
    }
};
import store from "../store"
import Api from "./Api2";

let changes = null;

let p = new Promise((resolve, reject) => {
    if(!store.state.changes){
        Api("tipo-cambio").get().then(res => {
            res.changes['SC-Compra'] = 1;
            changes = res.changes;
            store.commit("setChanges", res.changes)
            resolve()
        }).catch(() => {
            reject
        })   
    }else{
        changes = store.state.changes;
        resolve()
    }
})

const LC = {
    new(){
        const _this = this;
        return p.then( () => {
            return _this;
        })
    },
    isLoad: false,
    isInit: () => {
        return Boolean(changes)
    },
    init(){
        this.isLoad = true;
        let _this = this;
        return new Promise((resolve, reject) => {
            if(!store.state.changes){
                Api("tipo-cambio").get().then(res => {
                    res.changes['SC-Compra'] = 1;
                    changes = res.changes;
                    store.commit("setChanges", res.changes)
                    resolve(_this)
                }).catch(() => {
                    reject
                })   
            }else{
                changes = store.state.changes;
                resolve(_this)
            }
        })
    },
    get(country) {
        let price = changes[countryToChange[country].compra || countryToChange.USA.compra];
        let name = countryToChange[country].name || countryToChange.USA.name;
        return { price, name }
    },
    getList() {
        let arr = [];
        for (const i in changes) {
            if (!i.includes("Venta"))
                arr.push({
                    change: Number(changes[i]),
                    currency: i.split("-")[0]
                })
        }
        return arr;
    },
    localToSC({price, currency}){
        if(!price || !changes)
            return 0;
        let change = this.getList().find( e => e.currency == currency);
        if(change)
            return price / change.change;
        return -1
    }

}

export { LC }